export default "__VITE_ASSET__tRt8i8T___"